import {
  CLEAR_RUNUP_INFO,
  GET_RUNUP_INFO_REFERENCES_REQUEST,
  GET_RUNUP_INFO_REQUEST,
  RUNUP_INFO_REFERENCE_SORT,
  RUNUP_INFO_TOGGLE_COLUMN,
} from './runupInfoReducer';

export const clearRunupInfo = () => ({ type: CLEAR_RUNUP_INFO });
export const getRunupInfo = ({ id, history }) => ({ type: GET_RUNUP_INFO_REQUEST, id, history });
export const getRunupReferences = ({ id, history }) => ({ type: GET_RUNUP_INFO_REFERENCES_REQUEST, id, history });
export const sortReferences = sort => ({ type: RUNUP_INFO_REFERENCE_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: RUNUP_INFO_TOGGLE_COLUMN, visibleColumns });
